module.exports = __webpack_public_path__ + "img/chystam-party-header-background-mobile-fix-fix.3154881.png";